import { useEffect, useState } from "react"
import BasePage from "../../../components/BasePage/BasePage"
import api from "../../../config";
import { getParameter, getPermission, showMessageError } from "../../../classes/functions";
import ReactTooltip from "react-tooltip";
import { FaEye, FaPen } from "react-icons/fa";
import { Link } from "react-router-dom";
import PaginationPage from "../../../components/BasePage/Pagination";
import { parametersTypes } from "../../../classes/consts";

export default function GeneralParameters(){
    const [carrying, setCarrying] = useState(false);
    const [page, setPage] = useState(1);
    const [qtdePage, setQtdePage] = useState(50);
    const [termSearch, setTermSearch] = useState("");
    const [parametersByCompany, setParametersByCompany] = useState([]);

    function getParametersByCompanies(){
        api
        .get(`/api/parametros?search=${termSearch}&page=${page}&limit=${qtdePage}`)
        .then((response) => {
            setParametersByCompany(response.data.result);
        })
        .catch((error) => {
            console.log(error);

            if(error?.response?.data){
                showMessageError(error?.response?.data);
            }
        })
        .finally(() => {
            setCarrying(false);
        });
    }

    useEffect(() => {
        getParametersByCompanies();
    }, [, termSearch, page, qtdePage]);

    return (
        <BasePage 
            termSearch={{state: termSearch, setState: setTermSearch}}
            qtdePage={{state: qtdePage, setState: setQtdePage}} 
            title="Parâmetros Gerais" 
            URL="general_parameters"
            carrying={carrying} 
        >
            <table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Nome</th>
                        <th>Descrição</th>
                        <th>Tipo</th>
                        <th>Opções</th>
                    </tr>
                </thead>
                <tbody>
                    {parametersByCompany.map((parameterByCompany, index) => {
                        return (
                            <tr key={index}>
                                <td>{parameterByCompany?.id}</td>
                                <td>{parameterByCompany?.nome}</td>
                                <td>{parameterByCompany?.descricao}</td>
                                <td>{parametersTypes?.filter((parameterType) => parameterType?.value === parameterByCompany?.tipo)[0]?.label}</td>
                                <td>
                                    {getPermission('CONFIGURACOES - PARAMETROS GERAIS') && <Link className="action" to={`/general_parameters/cadastrar/u${parameterByCompany.id}`}>
                                        <FaPen color="#000" size={17} data-tip="Editar"/>
                                    </Link>}
                                    <ReactTooltip />
                                    <Link className="action" to={`/general_parameters/cadastrar/v${parameterByCompany.id}`} >
                                        <FaEye color="#000" size={19} data-tip="Visualizar"/>
                                    </Link>
                                    <ReactTooltip />
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            <br />
            <PaginationPage page={page} setPage={setPage} limit={qtdePage} />
        </BasePage>
    )
}